module.exports = __webpack_public_path__ + "static/media/fig_15a.2aeb262f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_15a.jpg
// module id = 644
// module chunks = 0